exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.small[data-v-866a5c7c]{\n  font-size: 12px!important;\n}\n.selectListBox[data-v-866a5c7c] {\n  background: #d4ebe9;\n  border: 1px solid grey;\n  padding: 3%;\n  max-height: 254px;\n  height: 254px;\n  overflow-y: scroll;\n  -webkit-transition: all .1s;\n  transition: all .1s;\n}\n.lightYellow[data-v-866a5c7c] {\n  background:   #f393241c\n}\n.custLabelFontSize[data-v-866a5c7c]{\n    font-size: 14px;\n}\n.selectBlock[data-v-866a5c7c]{\n    background: #eeeeee;\n    border: 1px solid #a5a5a5;\n    border-top: none;\n}\n.blockActive[data-v-866a5c7c]{\n    background: white;\n    border-bottom: none!important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-866a5c7c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cessioni/practicesToDo.vue
// module id = vIh7
// module chunks = 2